module.exports = __webpack_public_path__ + "y.no1.9d48daab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/y.no1.jpg
// module id = e6c2
// module chunks = 0